<template>

  <div class="proxy-container">
    <!-- 頭部 -->
    <div class="header">
      <h2 class="title">收銀臺</h2>
    </div>

    <div style="position: fixed; top: 30px; left: 30px;">
      <el-button icon="el-icon-arrow-left" @click="close" class="back-btn" plain size="small"></el-button>
    </div>

    <!-- 主要內容 -->
    <div class="content-container">
      <div style="max-width: 500px; margin: 0 auto;">

        <!-- 訂單信息 -->
        <div style="margin-bottom: 32px;">
          <div style="font-size: 20px; color: #3E4F7A; font-weight: 600; margin-bottom: 16px;">
            支付訂單
          </div>
          <div style="background: #F6F8FB; border-radius: 8px; padding: 16px;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
              <span style="color: #666;">訂單號：</span>
              <span style="color: #3E4F7A;">{{ payInfo.id }}</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
              <span style="color: #666;">支付金額：</span>
              <span style="color: #A3281C; font-weight: 600;">HKD {{ Number(payInfo.amount / 100).toFixed(2) }}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #666;">訂單狀態：</span>
              <span :style="{ color: orderStatus.color }">等待支付</span>
            </div>
          </div>
          <!-- <div style="color: #ED8E34; font-size: 12px; margin-top: 8px;">
            剩余支付時間：{{ countdown }} 過期後將關閉訂單
          </div> -->
        </div>

        <!-- FPS收款信息 -->
        <div style="margin-bottom: 24px;">
          <div style="font-size: 16px; color: #3E4F7A; font-weight: 600; margin-bottom: 16px;">
            🏦 轉數快收款信息
          </div>

          <!-- 收款人姓名 -->
          <div style="margin-bottom: 20px;">
            <div style="color: #666; margin-bottom: 8px;">收款人姓名</div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <div style="flex:1; padding: 12px; background: #fff; border-radius: 8px;
                    border: 1px solid #E0E0E0;">
                {{ payInfo.fps_name }}
              </div>
              <button @click="copyText(payInfo.fps_name)" style="padding: 12px; background: #F6F8FB; border-radius: 8px;
                        border: 1px solid #E0E0E0; cursor: pointer; height: 48px;">
                📋 復制
              </button>
            </div>
          </div>

          <!-- 收款賬號 -->
          <div style="margin-bottom: 20px;">
            <div style="color: #666; margin-bottom: 8px;">收款賬號</div>
            <div style="display: flex; align-items: center; gap: 8px;">
              <div style="flex:1; padding: 12px; background: #fff; border-radius: 8px;
                    border: 1px solid #E0E0E0; word-break: break-all;">
                {{ payInfo.fps_account }}
              </div>
              <button @click="copyText(payInfo.fps_account)" style="padding: 12px; background: #F6F8FB; border-radius: 8px;
                        border: 1px solid #E0E0E0; cursor: pointer; height: 48px;">
                📋 複製
              </button>
            </div>
          </div>



          <!-- 付款提示 -->
          <div style="padding: 12px; background: #FEF8EB; border-radius: 8px;">
            <div style="color: #ED8E34; font-size: 14px; line-height: 1.5;">
              ⚠️ 請務必在轉賬備註中填寫訂單號後4位：{{ shortOrderId }}
            </div>
          </div>
        </div>

        <!-- 支付完成按鈕 -->
        <button @click="confirmPayment" style="width: 100%; padding: 16px; background: #3E4F7A; color: white;
                  border-radius: 8px; font-size: 16px; border: none; cursor: pointer;
                  transition: opacity 0.3s;" :disabled="paymentLoading">
          {{ paymentLoading ? '正在驗證...' : '我已完成支付' }}
        </button>

        <!-- 複製成功提示 -->
        <transition name="fade">
          <div v-if="showCopySuccess" style="position: fixed; top: 20px; left: 50%; transform: translateX(-50%);
                 padding: 12px 24px; background: #43974E; color: white; border-radius: 8px;
                 box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
            ✅ 複製成功
          </div>
        </transition>

      </div>
    </div>
  </div>




</template>

<script>
export default {
  data() {
    return {
      paymentLoading: false,
      showCopySuccess: false,
      payInfo: {}
    }
  },
  mounted() {
    this.sendPayRequest()
  },
  computed: {
    shortOrderId() {
      return this.payInfo.id.slice(-4)
    },
    orderStatus() {
      return {
        text: '等待支付',
        color: '#43974E',

      }
    }
  },
  methods: {
    sendPayRequest() {

      this.$axios.post("/api/pay_order/add", {
        amount: this.$route.query.amount * 100
      }).then((res) => {
        if (res.data.status == 0) {
          this.payInfo = res.data.data
        }
      })

    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.showCopySuccess = true
        setTimeout(() => this.showCopySuccess = false, 2000)
      } catch (err) {
        console.error('複製失敗:', err)
        this.$message.error('複製失敗，請手動選擇複製')
      }
    },
    close() {
      this.$router.go(-1);
    },
    confirmPayment() {
      let _this = this

      this.$confirm('請確認您已完成以下操作：\n\n1. 已成功轉賬指定金額\n2. 轉賬備註包含訂單尾號\n3. 保留轉賬憑證',
        '確認支付完成', {
        confirmButtonText: '確認已完成',
        cancelButtonText: '返回檢查',
        type: 'warning'
      }).then(() => {

        this.paymentLoading = true
        this.$axios.post("/api/pay_order/pay", {
          id: _this.payInfo.id
        }).then((res) => {
          if (res.data.status == 0) {
            _this.paymentLoading = false
            _this.$router.push({ name: 'PayOrder' })
          }
        }).catch((err) => { 
          console.log(err)
        })
      }).catch(() => { })
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}

button:disabled {
  background: #E0E0E0 !important;
  cursor: not-allowed !important;
}
</style>
